module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Carousel Bearbeiten","form":{"fields":{"cycle":"Kreislauf"},"buttons":{"cancel":"Abbrechen","saveFormData":"Speichern"}}}}')
  delete Component.options._Ctor
}
